export default "__VITE_ASSET__CioMoTiG__"